var _style, _defs, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoRvb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 626.2 200",
    style: {
      enableBackground: "new 0 0 626.2 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000057116472586971379450000014459336532079148178_);}\r\n\t.st1{clip-path:url(#SVGID_00000072280982372082034330000000962362920488196769_);fill:#2F4C87;}\r\n\t.st2{clip-path:url(#SVGID_00000072280982372082034330000000962362920488196769_);fill:#A1B7DE;}\r\n\t.st3{clip-path:url(#SVGID_00000072280982372082034330000000962362920488196769_);fill:#6991CB;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 626.2,
    height: 200
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013151059386215124960000017338657675942017152_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000013151059386215124960000017338657675942017152_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000098917499725037901910000018092847929778185116_",
    width: 626.2,
    height: 200
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008115130882516127140000004270676120803187610_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098917499725037901910000018092847929778185116_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000008115130882516127140000004270676120803187610_)",
      fill: "#2F4C87"
    },
    d: "M288.5,36.9h24.6 v84.9c0,13.5-1.1,23-3.2,28.5c-2.2,5.5-5.7,9.8-10.7,13c-5,3.2-10.9,4.8-17.9,4.8c-14.2,0-26.3-6.2-36.3-18.5l17.7-16.4 c3.9,4.4,7.2,7.4,10,8.9c2.7,1.5,5.4,2.3,8,2.3c2.6,0,4.6-1.1,5.9-3.3c1.3-2.2,1.9-7.1,1.9-14.5V36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000008115130882516127140000004270676120803187610_)",
      fill: "#2F4C87"
    },
    d: "M339.2,70h23.8v45.6 c0,8.9,0.6,15,1.8,18.5c1.2,3.5,3.2,6.1,5.9,8.1c2.7,1.9,6,2.9,10,2.9c4,0,7.3-0.9,10.1-2.8c2.8-1.9,4.8-4.7,6.1-8.3 c1-2.7,1.5-8.6,1.5-17.5V70h23.8v40.1c0,16.5-1.3,27.9-3.9,33.9c-3.2,7.4-7.9,13.1-14.1,17.1c-6.2,4-14.1,6-23.6,6 c-10.4,0-18.8-2.3-25.2-7c-6.4-4.6-10.9-11.1-13.5-19.4c-1.9-5.7-2.8-16.2-2.8-31.3V70z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.8,
    y: 33.8,
    style: {
      clipPath: "url(#SVGID_00000008115130882516127140000004270676120803187610_)",
      fill: "#2F4C87"
    },
    width: 23.8,
    height: 131.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000008115130882516127140000004270676120803187610_)",
      fill: "#2F4C87"
    },
    d: "M498.4,31.4 c4.2,0,7.7,1.5,10.7,4.5c3,3,4.5,6.7,4.5,11c0,4.2-1.5,7.8-4.4,10.8c-3,3-6.5,4.5-10.6,4.5c-4.2,0-7.8-1.5-10.8-4.6 c-3-3-4.5-6.7-4.5-11.1c0-4.2,1.5-7.7,4.4-10.7C490.7,32.8,494.2,31.4,498.4,31.4 M486.2,70.8H510v94.6h-23.8V70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000008115130882516127140000004270676120803187610_)",
      fill: "#2F4C87"
    },
    d: "M601.5,70.8h23.8 v94.6h-23.8v-10c-4.7,4.4-9.3,7.6-14,9.5c-4.7,1.9-9.8,2.9-15.2,2.9c-12.3,0-22.9-4.7-31.8-14.2c-9-9.5-13.4-21.3-13.4-35.3 c0-14.6,4.3-26.6,13-35.9c8.7-9.3,19.2-14,31.6-14c5.7,0,11,1.1,16.1,3.2c5,2.1,9.6,5.4,13.9,9.7V70.8z M576.8,89.8 c-7.3,0-13.4,2.6-18.3,7.8c-4.9,5.2-7.3,11.8-7.3,20c0,8.2,2.5,14.9,7.4,20.2c4.9,5.3,11,7.9,18.3,7.9c7.5,0,13.6-2.6,18.6-7.8 c4.9-5.2,7.4-12,7.4-20.4c0-8.2-2.5-14.9-7.4-20C590.5,92.4,584.3,89.8,576.8,89.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000008115130882516127140000004270676120803187610_)",
      fill: "#A1B7DE"
    },
    d: "M148.5,168.5H20 c-11,0-20-8.9-20-20V20C0,8.9,8.9,0,20,0h128.6c11,0,20,8.9,20,20v128.6C168.5,159.5,159.5,168.5,148.5,168.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000008115130882516127140000004270676120803187610_)",
      fill: "#6991CB"
    },
    d: "M166.2,184.6H37.6 c-11,0-20-8.9-20-20V36.1c0-11,8.9-20,20-20h128.6c11,0,20,8.9,20,20v128.6C186.2,175.7,177.2,184.6,166.2,184.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000008115130882516127140000004270676120803187610_)",
      fill: "#2F4C87"
    },
    d: "M183.8,199.2H55.3 c-11,0-20-8.9-20-20V50.7c0-11,8.9-20,20-20h128.6c11,0,20,8.9,20,20v128.6C203.8,190.3,194.9,199.2,183.8,199.2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRvb);
export default __webpack_public_path__ + "static/media/Logo_RVB.be0896f03665f29f65d406ea042a5006.svg";
export { ForwardRef as ReactComponent };